const NETWORK_ERROR_MESSAGES = ['Failed to fetch', 'NetworkError', 'Load failed', 'fetch failed'];

/** tRPC wraps browser fetch errors in TRPCClientError and keeps the cause. */
export function isNetworkError(error: unknown): boolean {
  const seen = new Set<unknown>();
  let current = error;
  while (current instanceof Error && !seen.has(current)) {
    seen.add(current);
    const message = current.message;
    if (
      (current.name === 'TypeError' && NETWORK_ERROR_MESSAGES.some(fragment => message.includes(fragment))) ||
      message === 'Network request failed'
    ) {
      return true;
    }
    // Structured server errors must keep their original classification.
    if ((current as { data?: unknown }).data) return false;
    current = (current as Error & { cause?: unknown }).cause;
  }
  return false;
}
